module.exports = __webpack_public_path__ + "img/layers-two-01.17b562f0.svg";